import React from 'react';
import { withAllContexts } from '../AllContextsWrapper';
import { ChevronLeft, ChevronRight, Calendar } from 'lucide-react';

class BottomCalendarNavigator extends React.Component {
    changeDate = (amount) => {
        let dateObj = this.props.app.state.date;
        // Safely create date object
        let newDate = new Date(dateObj.year, dateObj.month - 1, 1);

        // Add month
        newDate.setMonth(newDate.getMonth() + amount);

        // Get new date object format using AppContext helper
        let newDateObj = this.props.app.functions.getDateObj(newDate);

        // Update state
        this.props.app.functions.changeCalDate(newDateObj, true);
    }

    goToToday = () => {
        let today = new Date();
        let todayObj = this.props.app.functions.getDateObj(today);
        
        // 1. Switch to month view if not already
        if (this.props.app.state.view !== 'month') {
            this.props.app.functions.setViewType('month');
        }
        
        // 2. Change date to today
        this.props.app.functions.changeCalDate(todayObj, true);
        
        // 3. Scroll to today (with small delay to ensure rendering)
        setTimeout(() => {
            const todayElement = document.querySelector('.ec_day_today');
            if (todayElement) {
                todayElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }, 100);
    }

    render() {
        const { date, activeCalendar } = this.props.app.state;
        const isCamping = activeCalendar?.type === 'accommodation';
        
        // Format: "Január 2024"
        const currentMonthLabel = new Date(date.year, date.month - 1, 1).toLocaleDateString('sk-SK', { month: 'long', year: 'numeric' });
        // Capitalize first letter
        const formattedLabel = currentMonthLabel.charAt(0).toUpperCase() + currentMonthLabel.slice(1);

        // Theme classes
        const bgClass = isCamping ? "bg-taborisko-beige border-taborisko-pine/10" : "bg-white border-gray-200";
        const topBarBgClass = isCamping ? "bg-taborisko-pine/5 border-taborisko-pine/10 text-taborisko-pine" : "bg-gray-50 border-gray-100 text-gray-800";
        const textClass = isCamping ? "text-taborisko-pine/70" : "text-gray-500";
        const iconClass = isCamping ? "text-taborisko-pine/80" : "text-gray-700";
        const btnHoverClass = isCamping ? "active:bg-taborisko-pine/5" : "active:bg-gray-100";
        const primaryColorClass = isCamping ? "text-taborisko-orange" : "text-splavma-teal";
        const primaryBgClass = isCamping ? "active:bg-taborisko-orange/10" : "active:bg-splavma-teal/10";

        return (
            <div className={`fixed bottom-0 left-0 right-0 border-t shadow-[0_-4px_10px_-1px_rgba(0,0,0,0.05)] z-40 pb-[env(safe-area-inset-bottom)] transition-colors duration-300 ${bgClass}`}>

                {/* Current Month Label - Compact */}
                <div className={`text-center py-1.5 border-b transition-colors duration-300 ${topBarBgClass}`}>
                    <span className="text-[11px] font-extrabold uppercase tracking-widest">
                        {formattedLabel}
                    </span>
                </div>

                <div className="flex items-center justify-between px-3 py-2 gap-2">

                    <button
                        onClick={() => this.changeDate(-1)}
                        className={`flex flex-col items-center justify-center p-2 rounded-xl transition-colors flex-1 ${btnHoverClass}`}
                    >
                        <ChevronLeft className={`w-5 h-5 mb-0.5 ${iconClass}`} />
                        <span className={`text-[10px] font-bold uppercase tracking-wider ${textClass}`}>Predošlý</span>
                    </button>

                    <button
                        onClick={this.goToToday}
                        className={`flex flex-col items-center justify-center p-2 rounded-xl transition-colors flex-[1.5] group ${primaryBgClass}`}
                    >
                        <div className="relative mb-0.5">
                            <Calendar className={`w-6 h-6 group-active:scale-110 transition-transform ${primaryColorClass}`} />
                        </div>
                        <span className={`text-[10px] font-bold uppercase tracking-wider ${primaryColorClass}`}>Dnes</span>
                    </button>

                    <button
                        onClick={() => this.changeDate(1)}
                        className={`flex flex-col items-center justify-center p-2 rounded-xl transition-colors flex-1 ${btnHoverClass}`}
                    >
                        <ChevronRight className={`w-5 h-5 mb-0.5 ${iconClass}`} />
                        <span className={`text-[10px] font-bold uppercase tracking-wider ${textClass}`}>Ďalší</span>
                    </button>
                </div>
            </div>
        );
    }
}

export default withAllContexts(BottomCalendarNavigator);
